import { render, staticRenderFns } from "./RequestDesktop.vue?vue&type=template&id=4771a166&scoped=true&"
import script from "./RequestDesktop.vue?vue&type=script&lang=js&"
export * from "./RequestDesktop.vue?vue&type=script&lang=js&"
import style0 from "./RequestDesktop.vue?vue&type=style&index=0&id=4771a166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771a166",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VNavigationDrawer,VRow})
